import React from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {EditorPanel, EditorColumn} from '../editor-components';
import {ImageUploader} from '../uploaders';
import ReactFireComponent from '../react-fire-component/react-fire-component';

/** @class ShowBackgrounds
  * A component for setting show-related background images
  * @param {Object} props - the component's properties
  */
export default class ShowBackgrounds extends ReactFireComponent {
  constructor(props){
    super(props);
    this.state = {
      backgrounds: {
        showLocations: '',
        exhibitorListing: '',
      }
    }
    this.dataURL = props.dataURL + '/backgrounds';
    this.handleImageUpload = this.handleImageUpload.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to its firebase realtime
    * database entry
    */
  componentWillMount(){
    this.bindAsObject(this.dataURL, 'backgrounds');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount(){
    this.unbind('backgrounds');
  }
  /** @method handleImageUpload
    * Saves the new image url as the associated property
    * @param {string} property - the property to set
    * @param {url} url - the image source url
    */
  handleImageUpload(property, url) {
    firebase.database().ref(`${this.dataURL}/backgrounds/${property}`).set(url);
  }
  /** @function render
    * Renders the component
    */
  render() {
    return (
      <EditorPanel>
        <EditorColumn>
          <ImageUploader
              name="showLocations"
              value={this.state.backgrounds.showLocations}
              dataURL={this.props.dataURL}
              onUpload={(url)=>this.handleImageUpload('showLocations', url)}
              />
        </EditorColumn>
        <EditorColumn>
          <ImageUploader
              name="exhibitorListing"
              value={this.state.backgrounds.exhibitorListing}
              dataURL={this.props.dataURL}
              onUpload={(url)=>this.handleImageUpload('exhibitorListing', url)}
              />
        </EditorColumn>
      </EditorPanel>
    )
  }
}



// WEBPACK FOOTER //
// ./src/show-editor/show-backgrounds.js